// contract-channel
import { axios } from '../index'
let scope = 'account'

export default {
  // 根据片区Id 和 角色名查询用户
  getUsersByRoleAndUnit: {
    workerName(unitId, aliasName) {
      return axios.get(
        `/${scope}/user/get/usersByRoleAndUnit/${unitId}/${aliasName}`
      )
    },
  },
  // 根据用户手机，获取所在片区集合
  getUserInfoOfZone(phone) {
    return axios.get(`/${scope}/user/getUserInfoByPhone/${phone}`)
  },
  // 根据片区id集合 获取所有社区集合
  getAllChildrenUnitsById(params) {
    return axios.post(`/${scope}/unit/listChildrenUnits`, params)
  },
  // 根据登录人Id,获取登录人信息
  getUserInfoByLoginId(id) {
    return axios.get(`/${scope}/user/info/id/${id}`)
  },
  // 企业用户相关
  businessInfo: params =>
    axios.post(`/${scope}/user/operation/enterpriseUser`, params),
  // 查询企业名称列表
  getCompanyList: params =>
    axios.post(`/${scope}/user/like/enterpriseUsers`, params),

  // 社区
  zones: {
    list() {
      return axios.get(`/${scope}/unit/tree/f/area`)
    },
  },
  // 权限 workflow
  privilege: {
    getAllRole: () => axios.get(`${scope}/work/role/treeAll`), // 获取所有角色及角色组
    getAllUnits: () => axios.get(`${scope}/work/unit/treeAll`), // 获取 所有片区的树状结构
    getSelfUnitsByUserId: (userId) => axios.get(`${scope}/unit/treeAreaByUser/${userId}`),
    // addNewWorker: (params) => axios.post(`${scope}/work/user/save`, params),  // 新增员工接口
    getWorkerList: params =>
      axios.post(`${scope}/work/user/listByNameAndPhone`, params),
    getUnitsAndRoleCount: (id) =>
      axios.get(`${scope}/work/unit/treeAllAndRoleCount/${id}`), // 获取所有片区和片区下的角色数
    getRoleListByUnit: params =>
      axios.post(`${scope}/work/user/listByUnit`, params), // 根据片区获取片区下的角色列表
    getUserList: value => axios.get(`${scope}/work/user/list/fuzzy/${value}`), // 查询用户列表
    updateUsersRoleList: params =>
      axios.post(`${scope}/work/role/update`, params), // 修改用户角色信息
    checkUserBacklog: userId =>
      axios.get(`${scope}/work/user/getBacklog/${userId}`), // 查询用户时候有代办事务
    cancelUsersAccount: params =>
      axios.post(`${scope}/work/user/cancel`, params), // 注销用户
    getUserInfo: params => axios.post(`${scope}/work/user/getInfo`, params), // 查看员工详细信息

    getRoleList: params => axios.post(`${scope}/work/role/list`, params), // 获取 角色管理列表
    getAllRoleGroup: () => axios.get(`${scope}/work/group/list`), // 获取所有角色组
    // addNewRole: params => axios.post(`${scope}/work/role/save`, params), // 添加角色
    updateRoleStatus: params =>
      axios.post(`${scope}/work/role/updateStatus`, params), // 修改角色状态
    checkAuthority: () => axios.get(`${scope}/work/menu/treeList`), // 查看权限树
    modifyRole: params => axios.post(`${scope}/work/role/update`, params), // 修改角色信息
    getAuthorityByRole: roleId =>
      axios.get(`${scope}/work/role/listPermission/${roleId}`), // 根据角色Id获取权限信息
    modifyAuthorityByRole: params =>
      axios.post(`${scope}/work/role/savePermission`, params), // 通过roleId添加和修改权限
    // 新增和修改员工接口整合
    addOrUpdateWorker: (type, params) =>
      type === 'ADD'
        ? axios.post(`${scope}/work/user/add`, params)
        : axios.post(`${scope}/work/user/update`, params),
    // 新增和修改角色的接口整合
    addOrUpdateRole: (type, params) =>
      type === 'ADD'
        ? axios.post(`${scope}/work/role/add`, params)
        : axios.post(`${scope}/work/role/update`, params),
    // 根据用户Id 获取其名下片区集合
    getUserUnitInfo: (userId) => axios.get(`${scope}/work/user/getUserPermissions/${userId}`),
  },
  // 根据用户Id获取其权限下的片区集合
  getZoneIdByUserId: userId =>
    axios.get(`/${scope}/unit/treeAreaByUserOfTwo/${userId}`),
  // 获取 片区集合
  getZoneListByArr: listAreaRequestBodies =>
    axios.post(`/${scope}/unit/list/new_simple_area`, listAreaRequestBodies),
  // 根据用户ID 获取用户角色
  getRoleListById: id => axios.get(`/${scope}/role/list/u/${id}`),
  // 根据用户Id 获取销售专员列表
  getSaleListById: id => axios.get(`/${scope}/role/list/f/u/T/${id}`),
  // 获取小管家列表
  getHouseKeeperById: id => axios.get(`/${scope}/role/list/f/u/X/${id}`),
  // 获取系统菜单目录
  getMenuList: userId => axios.get(`${scope}/work/menu/menuLoadOfReport/${userId}`),

  // 获取所有片区集合
  getUnitTree: () => axios.get(`${scope}/unit/tree/all`),
  // 新增片区
  addArea(params) {
    return axios.post(`/${scope}/work/unit/add`, params)
  },
}



// WEBPACK FOOTER //
// ./src/xhr/services/account.js